import { useState } from 'react';
import { sendPackageEnquiry } from '../../api/packages';
import { useAuth } from '../../auth/AuthContext';
import { addDaysIso, formatPrice } from '../../shared/data/common';

/** Quote request form for customized packages. */
export default function PackageEnquiryForm({ pkg }) {
  const { user } = useAuth();
  const [form, setForm] = useState({
    name: user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : '',
    email: user?.email || '',
    phone: '',
    preferredDate: '',
    adults: 2,
    children: 0,
    budget: '',
    message: '',
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const set = (field) => (event) => setForm((f) => ({ ...f, [field]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await sendPackageEnquiry(pkg.id, {
        ...form,
        preferredDate: form.preferredDate || null,
        adults: Number(form.adults),
        children: Number(form.children),
        budget: form.budget ? Number(form.budget) : null,
        message: form.message.trim() || null,
      });
      setSent(true);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div className="panel price-card">
        <h3>Thank you, {form.name.split(' ')[0]}!</h3>
        <p className="api-message success" role="status">Your enquiry for {pkg.title} has been sent. Our holiday expert will call you within 24 hours with a personalised quote.</p>
      </div>
    );
  }

  return (
    <form className="panel price-card" onSubmit={submit}>
      <span className="muted small">Starting from</span>
      <b className="price big">{formatPrice(pkg.price)}</b>
      <span className="muted small">per adult · final price depends on your choices</span>
      {error && <p className="api-message error" role="alert">{error}</p>}
      <label className="field"><span className="field-label">Your name</span>
        <input required minLength="2" maxLength="100" autoComplete="name" value={form.name} onChange={set('name')} />
      </label>
      <label className="field"><span className="field-label">Email</span>
        <input required type="email" maxLength="256" autoComplete="email" value={form.email} onChange={set('email')} />
      </label>
      <label className="field"><span className="field-label">Mobile number</span>
        <input required type="tel" minLength="7" maxLength="20" autoComplete="tel" value={form.phone} onChange={set('phone')} />
      </label>
      <label className="field"><span className="field-label">Preferred travel date (optional)</span>
        <input type="date" min={addDaysIso(1)} value={form.preferredDate} onChange={set('preferredDate')} />
      </label>
      <div className="form-grid">
        <label className="field"><span className="field-label">Adults</span>
          <input required type="number" min="1" max="50" value={form.adults} onChange={set('adults')} />
        </label>
        <label className="field"><span className="field-label">Children</span>
          <input required type="number" min="0" max="50" value={form.children} onChange={set('children')} />
        </label>
      </div>
      <label className="field"><span className="field-label">Total budget in ₹ (optional)</span>
        <input type="number" min="1" value={form.budget} onChange={set('budget')} />
      </label>
      <label className="field"><span className="field-label">What would you like to change?</span>
        <textarea rows="3" maxLength="2000" value={form.message} onChange={set('message')} placeholder="Hotels, extra nights, activities…" />
      </label>
      <button className="btn btn-primary block lg" disabled={busy}>{busy ? 'Sending…' : 'Get a free quote'}</button>
    </form>
  );
}
